import React, { useContext, useEffect, useState } from 'react'
import Radio, { Option } from '@Components/Fields/Radio'
import Button from '@Components/Buttons/Button'
import { observer } from 'mobx-react'
import { StoresContext } from '@App/contexts'
import { submitReportRequest } from '@App/api/routes/search'
import { ExportType } from '@App/enum/export-type'
import { MatchHistoryReportRequestDTO } from '@Entities/report/match-history-report-request'
import { SuggestionStatus } from '@Components/MatchComponents/v2/suggestion-status'

interface ExportMatchHistoryFormProps {
    setIsFormSubmitted: (isFormSubmitted: boolean) => void
}

const ExportMatchHistoryForm = (props: ExportMatchHistoryFormProps) => {
    const { exportStore, preloaderStore, rightsholderStore, matchHistoryStore } = useContext(StoresContext)

    const matchHistoryExportFormats = exportStore.exportFormats
    useEffect(() => {
        exportStore.setExportType(ExportType.MATCH_HISTORY)
        exportStore.loadExportFormats().then()
    }, [])

    const [matchHistoryReportRequest, setMatchHistoryReportRequest] = useState<MatchHistoryReportRequestDTO>({
        format: '',
        statuses: Object.entries(matchHistoryStore.matchSuggestionHistoryFilter)
            .filter(([key, value]) => value === true)
            .map(([key]) => key) as SuggestionStatus[],
    })
    const onFormatChange = (value: Option) => {
        setMatchHistoryReportRequest({
            ...matchHistoryReportRequest,
            format: value.value,
        })
    }
    const isFormValid = (): boolean => !!matchHistoryReportRequest?.format
    const onSubmitCatalogExportRequest = () => {
        if (isFormValid()) {
            preloaderStore.openTransparentPreloader(true)
            const rightsholderId = rightsholderStore.currentRightsholderId
            submitReportRequest(rightsholderId, matchHistoryReportRequest, ExportType.MATCH_HISTORY)
                .then(() => {
                    props.setIsFormSubmitted(true)
                })
                .finally(() => preloaderStore.openTransparentPreloader(false))
        }
    }

    return (
        <>
            <Radio
                options={matchHistoryExportFormats}
                field={{ name: 'File Type' }}
                direction="column"
                onChange={onFormatChange}
                title="File Type:"
            />
            <div className="download-button">
                <Button
                    mainColor
                    type="primary"
                    disabled={!isFormValid()}
                    onClick={() => onSubmitCatalogExportRequest()}
                >
                    Download
                </Button>
            </div>
        </>
    )
}

export default observer(ExportMatchHistoryForm)
